import { t } from 'i18next';

import { IContactGroup } from 'contacts/types';
import { AutocompleteFilter } from 'core/components/AgGridTable';
import { ChipListCell, LinkCell } from 'core/elements';
import { LinkTarget } from 'core/enums';
import { CorporateUserType } from 'corporate/enums';
import { corporateService } from 'corporate/services';
import { oldBomPartListPath } from 'jobs/routes/routePaths';
import { IJob } from 'jobs/types';

export const columnDef = (projectId: number) => {
  return [
    {
      colId: 'id',
      headerName: t('headerJobId'),
      field: 'id',
      filter: 'agNumberColumnFilter',
      cellClass: 'paddingSmall',
      minWidth: 80,
      cellRenderer: LinkCell,
      cellRendererParams: {
        getPath: (data: IJob) => oldBomPartListPath(data.projectId, data.id),
        target: LinkTarget.BLANK,
      },
      flex: 1,
    },
    {
      colId: 'name',
      headerName: t('headerJobName'),
      field: 'name',
      filter: 'agTextColumnFilter',
      flex: 2,
    },
    {
      colId: 'customers',
      headerName: t('headerCustomers'),
      field: 'customers',
      filter: AutocompleteFilter,
      filterParams: {
        autocompleteProps: {
          getOptions: corporateService.getCompaniesAutocomplete,
          placeholder: t('placeholderSelectCustomer'),
          requestPayload: {
            filters: {
              projectForeignCompany: {
                projectId,
                foreignCompanyType: CorporateUserType.CUSTOMER,
              },
            },
          },
        },
      },
      minWidth: 200,
      maxWidth: 500,
      cellRenderer: ChipListCell,
      cellRendererParams: {
        getChipValue: (customer: IContactGroup) => customer.name,
      },
      flex: 3,
    },
    {
      colId: 'vendors',
      headerName: t('headerVendors'),
      field: 'vendors',
      filter: AutocompleteFilter,
      filterParams: {
        autocompleteProps: {
          getOptions: corporateService.getCompaniesAutocomplete,
          placeholder: t('placeholderSelectVendor'),
          requestPayload: {
            filters: {
              projectForeignCompany: {
                projectId,
                foreignCompanyType: CorporateUserType.VENDOR,
              },
            },
          },
        },
      },
      minWidth: 200,
      maxWidth: 500,
      cellRenderer: ChipListCell,
      cellRendererParams: {
        getChipValue: (vendor: IContactGroup) => vendor.name,
      },
      flex: 3,
    },
  ];
};
